export default function logOut({commit}) {
    localStorage.clear()
    commit('LOGOUT')
}